export default __webpack_public_path__ + "static/media/welcome.5b7523b6.png";